import React from 'react';
import { createUseStyles, useTheme, Styles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import { Account, Participant } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  profileImage: {
    ...theme.fonts.h3,
    color: theme.colors.white,
    backgroundColor: theme.colors.red,
    width: 80,
    height: 80,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
  },
  smallProfileImage: {
    ...theme.fonts.h5,
    color: theme.colors.white,
    height: 40,
    width: 40,
  },
}));

interface Props {
  user: Participant | Account;
  small?: boolean;
}

export const ParticipantLogo = ({ user, small = false }: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classnames(classes.profileImage, {
        [classes.smallProfileImage]: small,
      })}
    >
      {user.firstName && user.firstName.charAt(0)}
      {user.lastName && user.lastName.charAt(0)}
      {!user.firstName && !user.lastName && user.email?.charAt(0)}
    </div>
  );
};
